import React from "react";
import { MessageCircle, Instagram, MapPin } from "lucide-react";
import { useLang } from "../context/LangContext";
import { WHATSAPP_NUMBER, INSTAGRAM } from "../lib/api";

export default function Contact() {
  const { t } = useLang();
  return (
    <div data-testid="contact-page" className="pt-40 pb-24 min-h-screen max-w-4xl mx-auto px-6">
      <p className="overline text-brand-primary mb-3">{t("nav_contact")}</p>
      <h1 className="font-heading text-5xl md:text-6xl font-light tracking-tighter text-ink mb-4">{t("contact_title")}</h1>
      <p className="text-ink-soft text-lg mb-14 max-w-lg">{t("contact_sub")}</p>

      <div className="grid sm:grid-cols-2 gap-6">
        <a
          href={`https://wa.me/${WHATSAPP_NUMBER}`}
          target="_blank"
          rel="noreferrer"
          data-testid="contact-whatsapp"
          className="group bg-canvas-soft p-8 hover:bg-canvas-deep transition-colors flex flex-col gap-3"
        >
          <MessageCircle size={28} strokeWidth={1.5} className="text-[#25D366]" />
          <span className="font-heading text-2xl text-ink">WhatsApp</span>
          <span className="text-ink-soft text-sm">+57 311 462 1866</span>
        </a>
        <a
          href={INSTAGRAM}
          target="_blank"
          rel="noreferrer"
          data-testid="contact-instagram"
          className="group bg-canvas-soft p-8 hover:bg-canvas-deep transition-colors flex flex-col gap-3"
        >
          <Instagram size={28} strokeWidth={1.5} className="text-brand-primary" />
          <span className="font-heading text-2xl text-ink">Instagram</span>
          <span className="text-ink-soft text-sm">@pasionaria30</span>
        </a>
      </div>

      <div className="mt-6 bg-canvas-soft p-8 flex items-center gap-3">
        <MapPin size={24} strokeWidth={1.5} className="text-brand-primary" />
        <span className="text-ink-soft">Colombia · Envíos a todo el país</span>
      </div>
    </div>
  );
}
